import { cn } from "@/lib/utils";
import { TeamLogo } from "@/components/ui/avatar";
import type { EventHeader } from "@/lib/odds-screen/live/types";
import { isTournament } from "./labels";

export function MatchupLogos({
  event,
  size = 20,
  className,
}: {
  event: Pick<EventHeader, "away" | "home" | "awayLogoUrl" | "homeLogoUrl">;
  size?: number;
  className?: string;
}) {
  if (isTournament(event)) return null;
  return (
    <span className={cn("flex flex-shrink-0 flex-col gap-0.5", className)}>
      <TeamLogo name={event.away} imageUrl={event.awayLogoUrl} size={size} />
      <TeamLogo name={event.home} imageUrl={event.homeLogoUrl} size={size} />
    </span>
  );
}
